import * as React from 'react';
import { Box } from '@mui/system';
import { Tab, Tabs, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/sharp-solid-svg-icons';
import { MultiStepContextProps } from './types';

type MultiStepFormHeaderProps = MultiStepContextProps & {
    /** Message d'erreur transverse par étape (même ordre que `steps`) ; `undefined` si valide. */
    stepErrors?: (string | undefined)[];
};

/**
 * En-tête du formulaire : onglets de navigation (clic libre entre les sections).
 * Remplace l'ancien stepper de wizard — chaque onglet persiste les valeurs courantes
 * avant de basculer (via `goToStep`).
 *
 * Un onglet dont la validation transverse échoue affiche une icône d'alerte
 * (couleur d'avertissement + tooltip décrivant le problème).
 */
const MultiStepFormHeader: React.FunctionComponent<MultiStepFormHeaderProps> = function (props) {
    const { steps, multiStepForm, stepErrors = [] } = props;
    const {
        currentStep: { index },
        goToStep,
    } = multiStepForm;

    return (
        <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
                value={index}
                onChange={(_, value) => goToStep(value as number)}
                variant="scrollable"
                scrollButtons="auto"
            >
                {steps.map(({ title }, stepIndex) => {
                    const error = stepErrors[stepIndex];
                    return (
                        <Tab
                            key={title}
                            label={title}
                            iconPosition="end"
                            icon={
                                error ? (
                                    <Tooltip title={error}>
                                        <Box
                                            component="span"
                                            sx={{ display: 'inline-flex', color: 'warning.main' }}
                                        >
                                            <FontAwesomeIcon icon={faTriangleExclamation} />
                                        </Box>
                                    </Tooltip>
                                ) : undefined
                            }
                            sx={error ? { color: 'warning.main' } : undefined}
                        />
                    );
                })}
            </Tabs>
        </Box>
    );
};

export default MultiStepFormHeader;
